import {
  FetchMoreMyActivitiesThunk,
  FetchMyActivitiesThunk,
  FetchMyActivityPaymentsThunk,
} from './myActivitiesActions';
import { useAppAction, useAppSelector } from '../hooks';
import { MyActivitiesState } from './myActivitiesTypes';
import { MY_ACTIVITIES_NAMESPACE } from './myActivitiesReducer';

export function useMyActivitiesSelector<
  T extends (state: MyActivitiesState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) => selector(state[MY_ACTIVITIES_NAMESPACE]));
}

export const useMyActivities = () =>
  useMyActivitiesSelector((state) => {
    return state.myActivities;
  });

export const useMyActivitiesHasMore = () =>
  useMyActivitiesSelector((state) => {
    return (
      state.pagination.eventsTotalResult > state.pagination.eventsShown ||
      state.pagination.roomsTotalResult > state.pagination.roomsShown
    );
  });

export const useSelectedActivityPayments = () =>
  useMyActivitiesSelector((state) => {
    return state.selectedActivityPayments;
  });

export const useFetchMyActivities = () => useAppAction(FetchMyActivitiesThunk);

export const useFetchSelectedActivityPayments = () =>
  useAppAction(FetchMyActivityPaymentsThunk);

export const useFetchMoreMyActivities = () =>
  useAppAction(FetchMoreMyActivitiesThunk);
